module.exports = __webpack_public_path__ + "img/cake.2b6ac42a.svg";